<template>
  <div class="official-website">
    <!-- 顶部Banner -->
    <div
        class="banner"
        :style="`background: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.5)), url(${website.base.bannerBg}) center center / cover no-repeat`"
    >
      <div class="banner-content">
        <h1>{{ website.base.title }}</h1>
        <p>{{ website.base.slogan }}</p>
        <a href="#register" class="btn banner-btn">立即报名</a>
      </div>
    </div>

    <!-- 动态渲染所有板块 -->
    <div v-for="section in website.sections" :key="section.id" :id="section.id" class="section">
      <div class="container">
        <!-- 板块标题（导航板块隐藏标题） -->
        <div class="section-title" v-if="section.title">
          <h2>{{ section.title }}</h2>
          <p>{{ section.desc }}</p>
        </div>
        <!-- 动态组件：通过函数返回组件，解决ESLint报错 -->
        <component
            :is="getComponent(section.component)"
            :data="section.data"
            :theme="website.theme"
            :org-data="website.orgData"
            :video="section.video"
        />
      </div>
    </div>

    <!-- 页脚 -->
    <footer class="footer" :style="`background-color: ${website.theme.primaryColor}; color: white;`">
      <div class="container">
        <div class="footer-content">
          <p>{{ website.footer.contact }}</p>
          <p>{{ website.footer.copyright }}</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, onMounted, provide } from 'vue';
import { getWebsiteConfig,getOfficialInfo } from '@/api/website';

// 导入所有子组件
import NavStep from '@/components/NavStep.vue';
import IntroCard from '@/components/IntroCard.vue';
import PathList from '@/components/PathList.vue';
import ReviewGallery from '@/components/ReviewGallery.vue';
import ScheduleStep from '@/components/ScheduleStep.vue';
import RegisterForm from '@/components/RegisterForm.vue';

// 核心：组件映射函数（让ESLint识别组件已使用）
const getComponent = (componentName) => {
  const componentsMap = {
    NavStep,
    IntroCard,
    PathList,
    ReviewGallery,
    ScheduleStep,
    RegisterForm
  };
  return componentsMap[componentName] || null;
};

// 存储官网配置
const website = ref({
  base: {},
  theme: {},
  sections: [],
  footer: {},
});

// 全局提供官网配置（供子组件备用）
provide('$website', website);

// 加载配置
onMounted(async () => {
  const config = await getWebsiteConfig('starPathCup');
  console.log('官方信息1:', config);
 // website.value = config;
  //document.title = config.base.title;
  // 获取官方信息
  try {
    const hostname = window.location.hostname; // 主机名，如 example.com
    console.log('官方信息啥玩意：',hostname);
    const officialInfo = await getOfficialInfo({"officialUrl":hostname});
    console.log('官方信息:', officialInfo.data.data.data);
    website.value = officialInfo.data.data.data;
    document.title = officialInfo.data.data.data.base.title;
  } catch (error) {
    console.error('获取官方信息失败:', error);
  }
});
</script>

<style scoped lang="scss">
// 基础样式重置（仅作用于当前组件内部）
.official-website {
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  // 按钮样式（官网专用）
  .btn {
    display: inline-block;
    padding: 12px 24px;
    background-color: v-bind('website.theme.primaryColor');
    color: white;
    border: none;
    border-radius: 30px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: #e63969; // 主色加深10%
      transform: translateY(-2px);
    }
  }

  // 板块标题样式
  .section-title {
    text-align: center;
    margin-bottom: 40px;

    h2 {
      font-size: 28px;
      color: v-bind('website.theme.primaryColor');
      margin-bottom: 10px;
      position: relative;
      display: inline-block;

      &::after {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 3px;
        background-color: v-bind('website.theme.secondaryColor');
        border-radius: 3px;
      }
    }

    p {
      font-size: 16px;
      color: #666;
      max-width: 800px;
      margin: 0 auto;
    }
  }
}

// Banner样式
.banner {
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;

  .banner-content {
    max-width: 1000px;
    padding: 0 20px;

    h1 {
      font-size: 48px;
      margin-bottom: 20px;
      text-shadow: 0 2px 8px rgba(0,0,0,0.3);
    }

    p {
      font-size: 20px;
      margin-bottom: 32px;
      text-shadow: 0 2px 8px rgba(0,0,0,0.3);
    }

    .banner-btn {
      font-size: 18px;
      padding: 14px 32px;
    }
  }
}

// 板块样式
.section {
  padding: 80px 0;

  &:nth-child(even) {
    background-color: white;
  }

  &:nth-child(odd):not(:first-child) {
    background-color: v-bind('website.theme.lightBg');
  }
}

// 页脚样式
.footer {
  padding: 40px 0;

  .footer-content {
    text-align: center;

    p {
      margin-bottom: 8px;
      font-size: 14px;
    }
  }
}

// 平滑滚动
html {
  scroll-behavior: smooth;
}
</style>